import i18n from "../../../../../constants/i18n";
import { BANNED_USERS_HEADERS } from "../../../../../constants/table-custom-headers/Supervisor";
import getFlaggedDesctiprionStore from "../../../../../stores/supervisor-store/flagged-description-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Table from "../../../../../core/et3-table";

const UsersBannedData = withLiteObserverAndTheme(() => {
  const bannedUsers = getFlaggedDesctiprionStore().bannedUsers.get();

  return (
    <Et3Table
      columns={BANNED_USERS_HEADERS}
      rows={bannedUsers}
      title={i18n.get("BANNED_USERS")}
      shouldBeFlagged={false}
      titleKey={"BANNED_USERS_TABLE"}
    />
  );
});

export default UsersBannedData;
